import { Dayjs, PluginFunc, UnitType } from 'dayjs';

declare module 'dayjs' {
  interface Dayjs {
    round(amount: number, unit: string): Dayjs;
    ceil(amount: number, unit: string): Dayjs;
    floor(amount: number, unit: string): Dayjs;
  }
}

const round: PluginFunc = (option, dayjsClass) => {
  dayjsClass.prototype.round = function (amount: number, unit: string): Dayjs {
    if (this.get(unit as UnitType) % amount >= amount / 2) {
      return this.ceil(amount, unit);
    } else {
      return this.floor(amount, unit);
    }
  };
};

export default round; 